/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tab/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tab({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/Payers/Content/Tab"
  
}) {
let payerIdValueData = fromData.useDataValue({ viewPath,
context: 'payer',
path: 'id',
})
let payersActivetabIdValueData = fromData.useDataValue({ viewPath,
context: 'payers',
path: 'activeTab.id',
})
let aggregateData = fromAggregate.equals(payerIdValueData, payersActivetabIdValueData)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtColorsBrandGreen = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.brand.green'
        })
let payerNameValueData = fromData.useDataValue({ viewPath,
context: 'payer',
path: 'name',
})
let payerIdValueData1 = fromData.useDataValue({ viewPath,
context: 'payer',
path: 'id',
})
let payersActivetabIdValueData1 = fromData.useDataValue({ viewPath,
context: 'payers',
path: 'activeTab.id',
})
let aggregateData1 = fromAggregate.equals(payerIdValueData1, payersActivetabIdValueData1)
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<div
  data-testid="Tab.Vertical"
  data-view-path={viewPath}
 style={{'--pb-1-mwf': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mr-2-mwf': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--bbc-3-mwf': aggregateData ? dtColorsBrandGreen : dtColorsBrandGreen,'--bs-4-mwf': aggregateData ? "solid" : "solid",'--bbw-5-mwf': aggregateData ? "2px" : "0px"}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={aggregateData1 ? dtColorsBrandGreen : dtColorsNeutral900}
 weight="medium"
 data="payer.name"
 text={payerNameValueData}
 data="payer.id"
 data="payers.activeTab.id"
 aggregate="/Data/aggregate.js equals"
/>
</div>
{children}
</React.Fragment>)
}